// Compensation visibility (comp/payroll authz Phase 1B/5b). The payroll API never sends pay
// to someone without compensation:view for that person: a field is OMITTED (absent or
// null), or the compensation endpoint answers 403. The UI must say "restricted" for that —
// never render it as 0, "—" or "Not set", which all claim something about the person's pay.
import { getCompensation } from '@/lib/compensationApi';

export const RESTRICTED_PAY_MESSAGE = "Restricted — you don't have access to pay for this person";
export const RESTRICTED_SHORT = 'Restricted';

export type PayAccess = 'allowed' | 'restricted' | 'unknown';

const httpStatus = (e: unknown) => (e as { response?: { status?: number } })?.response?.status;

/** A 403 from a compensation read = the caller may not see this person's pay. */
export const isPayForbidden = (e: unknown) => httpStatus(e) === 403;

/**
 * A profile read that came back WITHOUT a salary is ambiguous: no salary on record, or a
 * caller who may not see it. The compensation endpoint tells them apart (403 = restricted).
 * 404 (not on payroll) and an empty list are "allowed, nothing set". Anything else is
 * 'unknown' — never guessed as either.
 */
export async function probePayAccess(employeeId: string): Promise<PayAccess> {
  try {
    await getCompensation(employeeId);
    return 'allowed';
  } catch (e) {
    if (isPayForbidden(e)) return 'restricted';
    if (httpStatus(e) === 404) return 'allowed';
    return 'unknown';
  }
}

/** A money field from a projected response: absent/null = restricted (not zero). */
export const isWithheld = (v: unknown) => v === undefined || v === null || v === '';
